import { ForbiddenError } from '@crm/components/Error'
import { useRolePermission } from '@crm/hooks/useRolePermission'
import { UserRoleCRM } from '@crm/types'
import { TitleSection } from '@shared/components'
import { useLocales } from '@shared/locales'
import { Outlet } from 'react-router-dom'

export const ReportsLayout = () => {
  const { t } = useLocales()
  const hasPermissionExpert = useRolePermission([UserRoleCRM.expert])

  if (hasPermissionExpert) return <ForbiddenError />

  return (
    <>
      <TitleSection title={t(`reports.reports`)} />
      <Outlet />
    </>
  )
}
